"use strict";
var Promise = require("./promise/promise").Promise;
var polyfill = require("./promise/polyfill").polyfill;
exports.Promise = Promise;
exports.polyfill = polyfill;


//////////////////
// WEBPACK FOOTER
// ./~/es6-promise/dist/commonjs/main.js
// module id = 174
// module chunks = 0